/* eslint-disable @typescript-eslint/no-explicit-any */
/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
/*

  Note (Nov. 2022): 
  - zone.js import (commented below) has been moved from this file (polyfills.ts) to main.ts
  - do not uncommment and import zone.js in this file, it will cause Safari and Firefox to break
  - in order to get Safari and Firefox working after upgrading from Angular v7 --> v8 we had to move the zone.js import from this file to main.ts

  // import 'zone.js';  // Included with Angular CLI.
*/
// Add global to window, assigning the value of window itself.
// Required by some libraries like socket.io-client
(window as any).global = window;

// Minimal process shim for Node.js libraries (microsoft-cognitiveservices-speech-sdk, @tanstack/table-core)
// that reference process.env, process.nextTick, process.emitWarning at module load time.
(window as any).process = {
  env: {},
  nextTick: (fn: (...args: any[]) => void, ...args: any[]) => queueMicrotask(() => fn(...args)),
  emitWarning: () => {
    /* shim: warnings are dropped in the browser */
  },
  version: '',
};

// Promise.withResolvers polyfill - needed for pdfjs-dist on iOS Safari < 17.4
if (typeof (Promise as any).withResolvers !== 'function') {
  (Promise as any).withResolvers = function () {
    let resolve: any, reject: any;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Reflect metadata polyfill - needed for Angular decorator metadata
import 'core-js/stable/reflect';

// HammerJS for touch gesture support
import 'hammerjs/hammer';

// Force Angular Material modules to be included (prevents empty chunk issue)
import '@angular/material/select';
import '@angular/material/tooltip';
